import { EnvironmentTypes } from '../constants/environmentTypes';

const liveEnvironment = (isGLI) => ({
  httpUrl: `${window.location.origin}/${isGLI ? 'lines-lab' : 'lines'}`,
  socketUrl: `${window.location.origin}/${isGLI ? 'lines-lab' : 'lines'}/api/`,
  httpTranslationUrl: `${window.location.origin}/translations/api/v1/Translations`,
  socketUrlJackpot: `${window.location.origin}/jackpot/api/JackpotHub`,
});

const stageEnvironment = (isGLI) => ({
  httpUrl: `https://pg-stage.rpd.cloud/${isGLI ? 'lines-lab' : 'lines'}`,
  socketUrl: `https://pg-stage.rpd.cloud/${isGLI ? 'lines-lab' : 'lines'}/api/`,
  socketUrlJackpot: 'https://pg-stage.rpd.cloud/jackpot/api/JackpotHub',
  httpTranslationUrl: 'https://pg-stage.rpd.cloud/translations/api/v1/Translations',
});

export const environmentBuilder = (isGLI = false) => {
  if (process.env.REACT_APP_ENV === EnvironmentTypes.Production) {
    return liveEnvironment(isGLI);
  }
  return stageEnvironment(isGLI);
};
